<script>
    import { fade, fly } from "svelte/transition";
    import Overlay from "./Overlay.svelte";

    export let onClick = function () {};
    export let title = "Valitse tallennustapa";
    export let text = "Tässä versiossa käytössä on vain laitteelle tallentaminen.";
    export let buttonText = "Selvä";
    export let open = false;

    let selectedMethod;
    let fileName = "aistikartoitus_vastaukset_" + new Date().toLocaleDateString().replaceAll(".", "-");

    $: if(selectedMethod) console.log(selectedMethod);

    function acceptButtonAction() {
        onClick(fileName, selectedMethod);

        setTimeout(() => {
            open = false;            
        }, 400);
    }
</script>

<style>
    .svelte-modal {
        background: #fff;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 480px;
        max-width: 85%;
        height: fit-content;
        max-height: 80%;
        padding: .8rem;
        background: #fff;
        text-align: center;
        font-size: 18px;
        overflow-y: auto;
        z-index: 300;
        border: 1px solid gray;
        border-radius: 20px;
    }
    .svelte-modal h2 {
        margin-bottom: 2rem;
    }
    .svelte-modal .action {
        display: flex;
        width: 100%;
        justify-content: space-evenly;
        justify-items: center;
        padding: 1rem .5rem;
        margin-top: 1rem;
    }
    .close-btn {
        position: absolute;
        top: 0.5rem;
        right: 1rem;
        font-weight: 600;
        border: none;
        background: none;
    }
    select {
        margin-top: 1.5rem;
    }
</style>

{#if open}
    <div class="svelte-modal" in:fly={{ duration: 200, y: 200 }} out:fade={{ duration: 200 }}>
        <!-- <button class="close-btn" on:click={ () => open = false }>X</button> -->
        
        <h2> { title } </h2>
        <p>{ text }</p> 
        
        <select class="select select-bordered w-full max-w-xs" bind:value={ selectedMethod }>
            <option disabled="disabled">Valitse tallennustapa</option> 
            <option value="file">Laitteelle tiedostona</option> 
            <option disabled value="localStorage" style="text-decoration: line-through;">Selaimen muistiin</option> 
        </select>

        {#if selectedMethod === "file" || selectedMethod === "localStorage"}
            <div class="form-control">
                <label class="label" for="filename">
                    <span class="label-text">Tiedoston nimi</span>
                </label> 
                <input type="text" id="filename" class="input input-bordered" bind:value={ fileName }>
            </div>
        {/if}

        <div class="action">
            <button class="btn" on:click={ () => open = false }>Peruuta</button>
            <button  class="btn btn-primary" on:click={ acceptButtonAction }
                disabled={ selectedMethod === "file" || selectedMethod === "localStorage" ? false : true }
            > 
                { buttonText } 
            </button> 
        </div>
    </div>

    <Overlay show={ open } on:click={ () => open = false } />
{/if}
